import { render } from "./MenuMoblie.vue?vue&type=template&id=224b0066"
import script from "./MenuMoblie.vue?vue&type=script&lang=js"
export * from "./MenuMoblie.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\iran\\iranrpm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__